export default __webpack_public_path__ + "static/media/female-blogger.45d178f6.png";